module.exports = __webpack_public_path__ + "img/scope3category13.dbebe9df.svg";